import { getLocalStorage } from "../utils/corsUtils";

export const Plausible = async (window) => {
  var plausibleHost = "https://plausible.io"
  var location = window.location
  var document = window.document

  var domain = location.host.replace("www.", "");
  var plausible_ignore = await getLocalStorage("plausible_ignore");

  var lastPage;

  function warn(reason) {
    console.warn('Ignoring Event: ' + reason);
  }

  function trigger(eventName, options) {
    if (/^localhost$|^127(?:\.[0-9]+){0,2}\.[0-9]+$|^(?:0*:)*?:?0*1$/.test(location.hostname) || location.protocol === 'file:') return warn('localhost');
    if (window.phantom || window._phantom || window.__nightmare || window.navigator.webdriver || window.Cypress) return;
    if (plausible_ignore==="true") return warn('localStorage flag');
          
    var payload = {}
    payload.n = eventName
    payload.u = location.href.split("/@")[0];
    payload.d = domain
    payload.r = document.referrer || null
    payload.w = window.innerWidth
    if (options && options.meta) {
      payload.m = JSON.stringify(options.meta)
    }
    if (options && options.props) {
      payload.p = JSON.stringify(options.props)
    }

    var request = new XMLHttpRequest();
    request.open('POST', plausibleHost + '/api/event', true);
    request.setRequestHeader('Content-Type', 'text/plain');

    request.send(JSON.stringify(payload));

    request.onreadystatechange = function() {
      if (request.readyState === 4) {
        options && options.callback && options.callback()
      }
    }
  }

  function page() {
    if (lastPage === location.pathname.split("/@")[0]) return;
    lastPage = location.pathname.split("/@")[0];
    trigger('pageview')
  }

  function handleVisibilityChange() {
    if (!lastPage && document.visibilityState === 'visible') {
      page()
    }
  }

  function handleOutbound(event) {
    var link = event.target;
    var middle = event.type === "auxclick" && event.which === 2;
    var click = event.type === "click";
      while(link && (typeof link.tagName == 'undefined' || link.tagName.toLowerCase() !== 'a' || !link.href)) {
        link = link.parentNode
      }

      if (link && link.href && link.host && link.host !== location.host) {
        if (middle || click)
        window.plausible('Outbound Link: Click', {props: {url: link.href}})

        // Delay navigation so that Plausible is notified of the click
        if(!link.target || link.target.match(/^_(self|parent|top)$/i)) {
          if (!(event.ctrlKey || event.metaKey || event.shiftKey) && click) {
            setTimeout(function() {
              location.href = link.href;
            }, 150);
            event.preventDefault();
          }
        }
      }
  }

  function registerOutboundLinkEvents() {
    document.addEventListener('click', handleOutbound)
    document.addEventListener('auxclick', handleOutbound)
  }

  try {
    var his = window.history
    if (his.pushState) {
      var originalPushState = his['pushState']
      his.pushState = function() {
        originalPushState.apply(this, arguments)
        page();
      }
      window.addEventListener('popstate', page)
    }

    registerOutboundLinkEvents()

    var queue = (window.plausible && window.plausible.q) || []
    window.plausible = trigger
    for (var i = 0; i < queue.length; i++) {
      trigger.apply(this, queue[i])
    }

    if (document.visibilityState === 'prerender') {
      document.addEventListener("visibilitychange", handleVisibilityChange);
    } else {
      page()
    }
  } catch (e) {
    console.error(e)
    new Image().src = plausibleHost + '/api/error?message=' +  encodeURIComponent(e.message);
  }
}